export const MODULE_ROUTE = {
  // App Info
  'Landing_Page' : '*',
  'Logout': '/logout',
  'Login': '/login'
}